/**
 * @Author: Nemo
 * @Description: 模拟API数据
 * @Date: 2024-11-30
 * @FilePath: /rhcn-checkout-web/src/views/test/checkout/mock-api.js
 */

import { createRowFields } from '@/componentsV2/busi/dynamic-form';

/**
 * 接口返回字段说明：
 * 所有字段永远只包含四个属性：
 * - name: 字段key
 * - value: 字段默认值
 * - display: 是否显示（Y/N）
 * - require: 是否必填（Y/N）
 */

// 模拟API返回的表单字段配置
export const mockFormFields = [
  {
    name: 'address',
    require: 'Y',
    value: 'Unit 1113, 11/F, Tower 2, Cheung Sha Wan Plaza, 833 Cheung Sha Wan Road, Lai Chi Kok',
    display: 'Y',
  },
  {
    name: 'city',
    require: 'Y',
    value: 'US',
    display: 'Y',
  },
  {
    name: 'country',
    require: 'Y',
    value: 'US',
    display: 'Y',
  },
  {
    name: 'email',
    require: 'Y',
    value: 'huizhen.d6ai@pacypay.com',
    display: 'Y',
  },
  {
    name: 'firstName',
    require: 'Y',
    value: 'test',
    display: 'Y',
  },
  {
    name: 'lastName',
    require: 'Y',
    value: 'test',
    display: 'Y',
  },
  {
    name: 'contactName',
    require: 'Y',
    value: '', // 行字段本身通常不需要值
    display: 'Y',
  },
  {
    name: 'number',
    require: 'Y',
    value: '10',
    display: 'Y',
  },
  {
    name: 'phone',
    require: 'Y',
    value: '1234567890',
    display: 'Y',
  },
  {
    name: 'postalCode',
    require: 'Y',
    value: '10024',
    display: 'Y',
  },
  {
    name: 'province',
    require: 'Y',
    value: 'AL',
    display: 'Y',
  },
  {
    name: 'street',
    require: 'Y',
    value: '8401 Skillman Street Apt. 2039, Bldg. ',
    display: 'Y',
  },
];

// 模拟支付信息字段
export const mockPaymentFields = [
  {
    name: 'bankName',
    require: 'Y',
    value: '',
    display: 'Y',
  },
  {
    name: 'birthDate',
    require: 'Y',
    value: '',
    display: 'Y',
  },
  {
    name: 'blikcode',
    require: 'Y',
    value: '',
    display: 'Y',
  },
  {
    name: 'cardHolderName',
    require: 'Y',
    value: '',
    display: 'Y',
  },
  {
    name: 'cardNum',
    require: 'Y',
    value: '',
    display: 'Y',
  },
  {
    name: 'cvv',
    require: 'Y',
    value: '',
    display: 'Y',
  },
  {
    name: 'effectiveDate',
    require: 'Y',
    value: '',
    display: 'Y',
  },
  {
    name: 'iBan',
    require: 'Y',
    value: '',
    display: 'Y',
  },
  {
    name: 'identityNumber',
    require: 'Y',
    value: '',
    display: 'Y',
  },
  {
    name: 'issueDate',
    require: 'Y',
    value: '',
    display: 'Y',
  },
  {
    name: 'jpFirstName',
    require: 'Y',
    value: '',
    display: 'Y',
  },
  {
    name: 'jpLastName',
    require: 'Y',
    value: '',
    display: 'Y',
  },
  {
    name: 'walletAccountName',
    require: 'Y',
    value: '',
    display: 'Y',
  },
];

// 模拟API请求获取表单字段配置
export function fetchFormFields(fieldType = 'billing') {
  return new Promise(resolve => {
    setTimeout(() => {
      if (fieldType === 'payment') {
        resolve(mockPaymentFields);
      } else {
        resolve(mockFormFields);
      }
    }, 300); // 模拟网络延迟
  });
}

// 模拟API请求获取支付字段配置
export function fetchPaymentFields() {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(mockPaymentFields);
    }, 300); // 模拟网络延迟
  });
}

// 模拟API提交表单数据
export function submitFormData(formData) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      // 模拟表单验证
      if (!formData.cardNum || !formData.cardHolderName) {
        reject(new Error('表单数据不完整'));
        return;
      }

      // 模拟成功提交
      resolve({
        success: true,
        orderNumber: 'ORD' + Date.now(),
        message: '支付请求已提交',
      });
    }, 500);
  });
}
